import { render, staticRenderFns } from "./specials-slider-v-luxury.vue?vue&type=template&id=0de91b04&scoped=true&"
import script from "./specials-slider-v-luxury.vue?vue&type=script&lang=js&"
export * from "./specials-slider-v-luxury.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=0de91b04&scoped=true&lang=css&"
import style1 from "./specials-slider-v-luxury.vue?vue&type=style&index=1&id=0de91b04&lang=scss&scoped=true&"
import style2 from "./specials-slider-v-luxury.vue?vue&type=style&index=2&id=0de91b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de91b04",
  null
  
)

export default component.exports